// extracted by mini-css-extract-plugin
export default {"wrapper":"FromAmount_wrapper__6uPhv"};